import { DataRoomFile, DataRoomFolder } from '../types/dataRoom';

export const sampleFolders: DataRoomFolder[] = [
  {
    id: 'f1',
    name: 'Financial',
    path: '/financial',
    subfolders: ['f1-1', 'f1-2'],
    files: ['d1', 'd2', 'd3']
  },
  {
    id: 'f1-1',
    name: 'Financial Statements',
    path: '/financial/statements',
    parentId: 'f1',
    files: ['d1', 'd2']
  },
  {
    id: 'f1-2',
    name: 'Tax Returns',
    path: '/financial/tax',
    parentId: 'f1',
    files: ['d3']
  },
  {
    id: 'f2',
    name: 'Legal',
    path: '/legal',
    subfolders: ['f2-1'],
    files: ['d4', 'd5']
  },
  {
    id: 'f2-1',
    name: 'Contracts',
    path: '/legal/contracts',
    parentId: 'f2',
    files: ['d4']
  }
];

export const sampleFiles: DataRoomFile[] = [
  {
    id: 'd1',
    name: 'Q4 2023 Financial Statements.pdf',
    type: 'application/pdf',
    size: 2500000,
    uploadDate: '2024-03-01T10:00:00Z',
    lastModified: '2024-03-01T10:00:00Z',
    version: 1,
    status: 'approved',
    folderId: 'f1-1',
    path: '/financial/statements',
    uploadedBy: 'Sarah Johnson',
    accessLevel: 'restricted',
    metadata: {
      category: 'financial',
      confidentiality: 'high',
      retention: '7 years'
    },
    permissions: {
      view: ['finance_team', 'executives'],
      download: ['finance_team'],
      modify: ['finance_team']
    },
    activityLog: [
      {
        action: 'upload',
        user: 'Sarah Johnson',
        timestamp: '2024-03-01T10:00:00Z'
      },
      {
        action: 'view',
        user: 'Michael Chen',
        timestamp: '2024-03-02T14:30:00Z'
      }
    ]
  },
  {
    id: 'd2',
    name: 'Financial Projections 2024.xlsx',
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    size: 1800000,
    uploadDate: '2024-03-02T09:00:00Z',
    lastModified: '2024-03-05T11:00:00Z',
    version: 2,
    status: 'review',
    folderId: 'f1-1',
    path: '/financial/statements',
    uploadedBy: 'Michael Chen',
    accessLevel: 'confidential',
    metadata: {
      category: 'financial',
      confidentiality: 'high',
      retention: '7 years'
    },
    permissions: {
      view: ['finance_team'],
      download: ['finance_team'],
      modify: ['finance_team_leads']
    },
    activityLog: [
      {
        action: 'upload',
        user: 'Michael Chen',
        timestamp: '2024-03-02T09:00:00Z'
      },
      {
        action: 'modify',
        user: 'Michael Chen',
        timestamp: '2024-03-05T11:00:00Z'
      }
    ]
  },
  {
    id: 'd3',
    name: '2023 Tax Returns.pdf',
    type: 'application/pdf',
    size: 3500000,
    uploadDate: '2024-03-03T15:00:00Z',
    lastModified: '2024-03-03T15:00:00Z',
    version: 1,
    status: 'approved',
    folderId: 'f1-2',
    path: '/financial/tax',
    uploadedBy: 'Emily Brown',
    accessLevel: 'restricted',
    metadata: {
      category: 'tax',
      confidentiality: 'high',
      retention: '10 years'
    },
    permissions: {
      view: ['finance_team', 'tax_team'],
      download: ['tax_team'],
      modify: ['tax_team_leads']
    },
    activityLog: [
      {
        action: 'upload',
        user: 'Emily Brown',
        timestamp: '2024-03-03T15:00:00Z'
      }
    ]
  },
  {
    id: 'd4',
    name: 'Master Services Agreement.docx',
    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    size: 1200000,
    uploadDate: '2024-03-04T13:00:00Z',
    lastModified: '2024-03-06T16:00:00Z',
    version: 3,
    status: 'review',
    folderId: 'f2-1',
    path: '/legal/contracts',
    uploadedBy: 'David Wilson',
    accessLevel: 'confidential',
    metadata: {
      category: 'legal',
      confidentiality: 'high',
      retention: '10 years'
    },
    permissions: {
      view: ['legal_team', 'executives'],
      download: ['legal_team'],
      modify: ['legal_team_leads']
    },
    activityLog: [
      {
        action: 'upload',
        user: 'David Wilson',
        timestamp: '2024-03-04T13:00:00Z'
      },
      {
        action: 'modify',
        user: 'David Wilson',
        timestamp: '2024-03-06T16:00:00Z'
      }
    ]
  },
  {
    id: 'd5',
    name: 'Regulatory Compliance Report.pdf',
    type: 'application/pdf',
    size: 4200000,
    uploadDate: '2024-03-05T11:30:00Z',
    lastModified: '2024-03-05T11:30:00Z',
    version: 1,
    status: 'approved',
    folderId: 'f2',
    path: '/legal',
    uploadedBy: 'Sarah Johnson',
    accessLevel: 'restricted',
    metadata: {
      category: 'compliance',
      confidentiality: 'high',
      retention: '7 years'
    },
    permissions: {
      view: ['legal_team', 'compliance_team', 'executives'],
      download: ['compliance_team'],
      modify: ['compliance_team_leads']
    },
    activityLog: [
      {
        action: 'upload',
        user: 'Sarah Johnson',
        timestamp: '2024-03-05T11:30:00Z'
      }
    ]
  }
];